import { env } from "@src/utils/env/env"

const larryVsHarry = "f26200"
const dance = env === "production" ? "a14fe0" : "be084f"
const greenMoves = "2b3544"
export const customization = {
  hideDeviceDetailsRouteTabPartnerUuids: [larryVsHarry, greenMoves],
  hideMapPartnerUuids: [dance],
}
